import { ChainType } from '@lifi/types';
export function isSui(provider) {
    return provider.type === ChainType.MVM;
}
export const SuiTokenShortAddress = '0x2::sui::SUI';
export const SuiTokenLongAddress = '0x0000000000000000000000000000000000000000000000000000000000000002::sui::SUI';
//# sourceMappingURL=types.js.map